import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';
const SvgGlobeLanguage = ({
  accessibilityText,
  forwardedRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: 24,
  height: 24,
  "aria-hidden": accessibilityText ? undefined : true,
  "aria-label": accessibilityText,
  fill: "currentColor",
  focusable: false,
  ref: forwardedRef,
  role: accessibilityText ? 'img' : undefined
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m8.03 9h-4.05c-.11-2.68-.64-5.04-1.42-6.68A8.11 8.11 0 0 1 20.03 11M12 20.08c-.61-.37-1.88-2.79-2.06-7.08h4.13c-.18 4.28-1.45 6.7-2.06 7.08ZM9.94 11c.18-4.28 1.45-6.7 2.06-7.08.61.37 1.88 2.79 2.06 7.08H9.93Zm-.5-6.68c-.78 1.63-1.31 4-1.42 6.68H3.97a8.11 8.11 0 0 1 5.47-6.68M3.97 13h4.05c.11 2.68.64 5.04 1.42 6.68A8.11 8.11 0 0 1 3.97 13m10.59 6.68c.78-1.63 1.31-4 1.42-6.68h4.05a8.11 8.11 0 0 1-5.47 6.68"
}));
export default SvgGlobeLanguage;